var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuropaLeagueLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 56,
    viewBox: "0 0 47 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 54.9404H13.4711L13.7182 54.268L15.3461 49.8382L15.4665 49.5107H15.8154H31.2086H31.5644L31.681 49.8468L33.2178 54.2766L33.4481 54.9404H32.7454H14.1875Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7607 48.4048H20.1392L20.2723 47.7977L22.9727 35.4834H23.9495L26.6499 47.7977L26.783 48.4048H26.1615H20.7607Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4906 48.4048H15.7812L16.0197 47.7367L20.4883 35.217L12.0332 6.61082L11.9085 6.18898L12.311 6.01157L22.5926 1.47988L23.2943 1.17062V1.93741V32.6297V32.6847L23.2824 32.7383L19.8841 48.0134L19.797 48.4048H19.3961H16.4906Z",
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6436 1.96804L23.6421 1.19836L24.3459 1.50984L34.5534 6.02718L34.9527 6.20387L34.8314 6.6233L26.5371 35.306L30.9413 47.7373L31.1776 48.4043H30.47H27.556H27.1539L27.0677 48.0115L23.715 32.7364L23.7035 32.6839L23.7034 32.6302L23.6436 1.96804Z",
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6285 51.4739C41.6656 47.551 46.4283 40.0212 46.4283 31.3756C46.4283 23.1666 42.1342 15.9627 35.6724 11.8977L34.5729 15.8076C39.2672 19.2681 42.3165 24.8681 42.3165 31.189C42.3165 38.0798 38.6918 44.1149 33.2598 47.4534L34.6285 51.4739Z",
    fill: "#FA6E07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.29 51.4285C5.29693 47.4927 0.571289 39.9872 0.571289 31.3762C0.571289 23.2346 4.79559 16.0824 11.1662 12.0002L12.3227 15.8642C7.67256 19.329 4.65602 24.9017 4.65602 31.1881C4.65602 38.0933 8.29638 44.1384 13.7441 47.4726L12.29 51.4285Z",
    fill: "#FA6E07"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropaLeagueLogo);
export default __webpack_public_path__ + "static/media/europa-league-logo.75fd365eebe07ace0d450f9825b519a3.svg";
export { ForwardRef as ReactComponent };